import { createRouter,createWebHashHistory} from 'vue-router'
import index from "../views/index"

const routes = [
  {
    path:"/",
    redirect:"/home"
  },
  {
    path:"/home",
    name: '',
    component: index,
    children:[{
      path:'',
      component: () => import(/* webpackChunkName: 'login' */ '../views/Home.vue')
    }]
  },
  {
    path:"/about",
    name: '',
    component: index,
    children:[{
      path:'',
      component: () => import(/* webpackChunkName: 'login' */ '../views/About')
    }]
  },
  {
    path:"/product",
    name: '',
    component: index,
    children:[{
      path:'',
      component: () => import(/* webpackChunkName: 'login' */ '../views/product')
    }]
  },
  {
    path:"/support",
    name: '',
    component: index,
    children:[{
      path:'',
      component: () => import(/* webpackChunkName: 'login' */ '../views/support')
    }]
  },
  {
    path:"/application",
    name: '',
    component: index,
    children:[{
      path:'',
      component: () => import(/* webpackChunkName: 'login' */ '../views/application')
    }]
  },
  {
    path:"/detail",
    name: '',
    component: index,
    children:[{
      path:'',
      component: () => import(/* webpackChunkName: 'login' */ '../views/productDetail')
    }]
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router

